/* Global - assets/js
   ---------------------------------------------------------------- */

/**
 * Vanilla JS
 */

/**
 * Loading
 */
window.onload = function() {
	const spinner = document.getElementById( 'loading' );

	function loaded() {
		if ( spinner ) {
			spinner.classList.add( 'loaded' );
		}
	}
	setTimeout( loaded, 240 );
};

/**
 * Scroll → Fade in
 */

// Vertical top >> bottom
const iSObserversFadeInYT = document.querySelectorAll( '.u-fade__in-yt' );
const optionsFadeInYT = {
	rootMargin: '-10% 0px',
};

const fadeInYT = ( target ) => {
	target.classList.add( 'u-fade__in-yt-on' );
};

const observeUseFadeInYT = ( entries ) => {
	entries.forEach( ( entry ) => {
		if ( entry.isIntersecting ) {
			fadeInYT( entry.target );
		}
	});
};

const observerFadeInYT = new IntersectionObserver(
	observeUseFadeInYT,
	optionsFadeInYT
);
iSObserversFadeInYT.forEach( ( iSObserverFadeInYT ) => {
	observerFadeInYT.observe( iSObserverFadeInYT );
});

// Vertical bottom >> top
const iSObserversFadeInYB = document.querySelectorAll( '.u-fade__in-yb' );
const optionsFadeInYB = {
	rootMargin: '-10% 0px',
};

const fadeInYB = ( target ) => {
	target.classList.add( 'u-fade__in-yb-on' );
};

const observeUseFadeInYB = ( entries ) => {
	entries.forEach( ( entry ) => {
		if ( entry.isIntersecting ) {
			fadeInYB( entry.target );
		}
	});
};

const observerFadeInYB = new IntersectionObserver(
	observeUseFadeInYB,
	optionsFadeInYB
);
iSObserversFadeInYB.forEach( ( iSObserverFadeInYB ) => {
	observerFadeInYB.observe( iSObserverFadeInYB );
});

// Horizontal left >> right
const iSObserversFadeInXL = document.querySelectorAll( '.u-fade__in-xl' );
const optionsFadeInXL = {
	rootMargin: '-10% 0px',
};

const fadeInXL = ( target ) => {
	target.classList.add( 'u-fade__in-xl-on' );
};

const observeUseFadeInXL = ( entries ) => {
	entries.forEach( ( entry ) => {
		if ( entry.isIntersecting ) {
			fadeInXL( entry.target );
		}
	});
};

const observerFadeInXL = new IntersectionObserver(
	observeUseFadeInXL,
	optionsFadeInXL
);
iSObserversFadeInXL.forEach( ( iSObserverFadeInXL ) => {
	observerFadeInXL.observe( iSObserverFadeInXL );
});

// Horizontal right >> left
const iSObserversFadeInXR = document.querySelectorAll( '.u-fade__in-xr' );
const optionsFadeInXR = {
	rootMargin: '-10% 0px',
};

const fadeInXR = ( target ) => {
	target.classList.add( 'u-fade__in-xr-on' );
};

const observeUseFadeInXR = ( entries ) => {
	entries.forEach( ( entry ) => {
		if ( entry.isIntersecting ) {
			fadeInXR( entry.target );
		}
	});
};

const observerFadeInXR = new IntersectionObserver(
	observeUseFadeInXR,
	optionsFadeInXR
);
iSObserversFadeInXR.forEach( ( iSObserverFadeInXR ) => {
	observerFadeInXR.observe( iSObserverFadeInXR );
});

// Vertical top left >> bottom right
const iSObserversFadeInDTL = document.querySelectorAll( '.u-fade__in-dtl' );
const optionsFadeInDTL = {
	rootMargin: '-10% 0px',
};

const fadeInDTL = ( target ) => {
	target.classList.add( 'u-fade__in-dtl-on' );
};

const observeUseFadeInDTL = ( entries ) => {
	entries.forEach( ( entry ) => {
		if ( entry.isIntersecting ) {
			fadeInDTL( entry.target );
		}
	});
};

const observerFadeInDTL = new IntersectionObserver(
	observeUseFadeInDTL,
	optionsFadeInDTL
);
iSObserversFadeInDTL.forEach( ( iSObserverFadeInDTL ) => {
	observerFadeInDTL.observe( iSObserverFadeInDTL );
});

// Vertical top right >> bottom left
const iSObserversFadeInDTR = document.querySelectorAll( '.u-fade__in-dtr' );
const optionsFadeInDTR = {
	rootMargin: '-10% 0px',
};

const fadeInDTR = ( target ) => {
	target.classList.add( 'u-fade__in-dtr-on' );
};

const observeUseFadeInDTR = ( entries ) => {
	entries.forEach( ( entry ) => {
		if ( entry.isIntersecting ) {
			fadeInDTR( entry.target );
		}
	});
};

const observerFadeInDTR = new IntersectionObserver(
	observeUseFadeInDTR,
	optionsFadeInDTR
);
iSObserversFadeInDTR.forEach( ( iSObserverFadeInDTR ) => {
	observerFadeInDTR.observe( iSObserverFadeInDTR );
});

// Vertical bottom left >> top right
const iSObserversFadeInDBL = document.querySelectorAll( '.u-fade__in-dbl' );
const optionsFadeInDBL = {
	rootMargin: '-10% 0px',
};

const fadeInDBL = ( target ) => {
	target.classList.add( 'u-fade__in-dbl-on' );
};

const observeUseFadeInDBL = ( entries ) => {
	entries.forEach( ( entry ) => {
		if ( entry.isIntersecting ) {
			fadeInDBL( entry.target );
		}
	});
};

const observerFadeInDBL = new IntersectionObserver(
	observeUseFadeInDBL,
	optionsFadeInDBL
);
iSObserversFadeInDBL.forEach( ( iSObserverFadeInDBL ) => {
	observerFadeInDBL.observe( iSObserverFadeInDBL );
});

// Vertical bottom right >> top left
const iSObserversFadeInDBR = document.querySelectorAll( '.u-fade__in-dbr' );
const optionsFadeInDBR = {
	rootMargin: '-10% 0px',
};

const fadeInDBR = ( target ) => {
	target.classList.add( 'u-fade__in-dbr-on' );
};

const observeUseFadeInDBR = ( entries ) => {
	entries.forEach( ( entry ) => {
		if ( entry.isIntersecting ) {
			fadeInDBR( entry.target );
		}
	});
};

const observerFadeInDBR = new IntersectionObserver(
	observeUseFadeInDBR,
	optionsFadeInDBR
);
iSObserversFadeInDBR.forEach( ( iSObserverFadeInDBR ) => {
	observerFadeInDBR.observe( iSObserverFadeInDBR );
});

/**
 * Scroll → Under line
 */

// Vertical
const iSObserversUnderLineY = document.querySelectorAll( '.u-line__under-y' );
const optionsUnderLineY = {
	rootMargin: '-10% 0px',
};

const UnderLineY = ( target ) => {
	target.classList.add( 'u-line__under-y-on' );
};

const observeUseUnderLineY = ( entries ) => {
	entries.forEach( ( entry ) => {
		if ( entry.isIntersecting ) {
			UnderLineY( entry.target );
		}
	});
};

const observerUnderLineY = new IntersectionObserver(
	observeUseUnderLineY,
	optionsUnderLineY
);
iSObserversUnderLineY.forEach( ( iSObserverUnderLineY ) => {
	observerUnderLineY.observe( iSObserverUnderLineY );
});

// Horizontal
const iSObserversUnderLineX = document.querySelectorAll( '.u-line__under-x' );
const optionsUnderLineX = {
	rootMargin: '-10% 0px',
};

const UnderLineX = ( target ) => {
	target.classList.add( 'u-line__under-x-on' );
};

const observeUseUnderLineX = ( entries ) => {
	entries.forEach( ( entry ) => {
		if ( entry.isIntersecting ) {
			UnderLineX( entry.target );
		}
	});
};

const observerUnderLineX = new IntersectionObserver(
	observeUseUnderLineX,
	optionsUnderLineX
);
iSObserversUnderLineX.forEach( ( iSObserverUnderLineX ) => {
	observerUnderLineX.observe( iSObserverUnderLineX );
});

/**
 * Smooth scroll
 */
let scroll = new SmoothScroll( 'a[href*="#"]', {
	speedAsDuration: true,
	speed: 1200,
	easing: 'easeInOutQuad',
	header: '#fixed-header',
});

/**
 * Smooth scroll BTN hide
 */
const toTopArea = document.querySelector( '#header' );
const toTopBTN = document.getElementById( 'to-top' );

/*toTopBTN.addEventListener( 'click', function() {

	window.scrollTo({
		top: 0,
		behavior: 'smooth',
	});
});*/

const toTopCallback = ( entries ) => {
	if ( entries[0].isIntersecting ) {
		toTopBTN.style.opacity = '0';
		toTopBTN.style.pointerEvents = 'none';
	} else {
		toTopBTN.style.opacity = '1';
		toTopBTN.style.pointerEvents = 'auto';
	}
};

const toTopObserver = new IntersectionObserver( toTopCallback );
toTopObserver.observe( toTopArea );

/**
 * MW WP Formの<form>タグにyubinbango用のh-adrクラスを付ける
 */
const mwWpFormZip = document.querySelector( '.mw_wp_form form' );
if ( mwWpFormZip ) {
	mwWpFormZip.setAttribute( 'class', 'h-adr' );
}

/**
 * jQuery
 */
jQuery( document ).ready( function( $ ) {});
